import { useDispatch } from "react-redux";
import { AppDispatch, RootState, useAppSelector } from "../../redux/AppStore";
import { updateShipmentCountry } from "../../redux/slice/UpdateTrackingAddressSlice";
import { useEffect } from "react";

export default function ShipmentCountryComponent () {
  const dispatch = useDispatch<AppDispatch>();
  const customerCountry:string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_country_code);
  const countrylist = useAppSelector((state: RootState) => state.updateAddress.countryInfo);
  const countryName:string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_customer_country);
  useEffect(()=>{
   // console.log(customerCountry);
  },[customerCountry]);
  return (
        <div className="UpdateVerifyInput">
        <label>Country</label>
        <select className="form-select" aria-label="Select Country"
      value={customerCountry} 
      onChange={e => {
        let countryCode=e.target.value;
        let country=countrylist.find(c=>c.alpha3_code===countryCode);
       // console.log(countryCode,country);
        dispatch(updateShipmentCountry({name:country?.short_name??'',code:country?.alpha3_code??''}))
      }} 
      >
          <option>Select Country</option>
          {countrylist.map(c=><option value={c.alpha3_code}>{c.short_name}</option>)}
        </select>
      </div>
    );
}